
// NATIVE 

// INSTALLED 
import { setBeneficiariosRedux, setSizeItemsRedux } from './sizeItemsSlice';


// CUSTOM 


export const storeSizeItems = (size: number): any => {
  

  return async( dispatch: any ) => { 


      let sizeItems:any = [];

      for (let index = 1; index <= size; index++) {
          sizeItems.push(index);
      }

      await dispatch( setSizeItemsRedux(sizeItems) );

  }

    
}




export const storeItemsStore = (element: any): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( setBeneficiariosRedux(element) );

  }

    
}